/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BeforeSuccess_viewer$ref = any;
export type routes_BeforeSuccess_QueryVariables = {|
  ids?: ?$ReadOnlyArray<string>
|};
export type routes_BeforeSuccess_QueryResponse = {|
  +viewer: ?{|
    +salesOrders: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +verified: ?number,
          +grandTotal: ?number,
          +shippingTotal: ?number,
          +paymentMethod: ?string,
          +status: ?number,
          +discounts: ?$ReadOnlyArray<?{|
            +id: ?string,
            +name: ?string,
          |}>,
          +lines: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +quantity: ?number,
                +unitPrice: ?number,
                +rowTotal: ?number,
                +product: ?{|
                  +id: string,
                  +sku: ?string,
                  +name: ?string,
                  +brand: ?{|
                    +id: string,
                    +name: ?string,
                  |},
                |},
                +children: ?{|
                  +edges: ?$ReadOnlyArray<?{|
                    +node: ?{|
                      +id: string,
                      +name: ?string,
                      +quantity: ?number,
                      +unitPrice: ?number,
                      +product: ?{|
                        +id: string,
                        +sku: ?string,
                      |},
                    |}
                  |}>
                |},
              |}
            |}>
          |},
        |}
      |}>
    |},
    +$fragmentRefs: BeforeSuccess_viewer$ref,
  |}
|};
export type routes_BeforeSuccess_Query = {|
  variables: routes_BeforeSuccess_QueryVariables,
  response: routes_BeforeSuccess_QueryResponse,
|};
*/


/*
query routes_BeforeSuccess_Query(
  $ids: [ID!]
) {
  viewer {
    ...BeforeSuccess_viewer
    salesOrders(first: 1, ids: $ids) {
      edges {
        node {
          id
          name
          verified
          grandTotal
          shippingTotal
          paymentMethod
          status
          discounts {
            id
            name
          }
          lines(first: 99) {
            edges {
              node {
                id
                name
                quantity
                unitPrice
                rowTotal
                product {
                  id
                  sku
                  name
                  brand {
                    id
                    name
                  }
                }
                children(first: 99) {
                  edges {
                    node {
                      id
                      name
                      quantity
                      unitPrice
                      product {
                        id
                        sku
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    id
  }
}

fragment BeforeSuccess_viewer on Customer {
  salesOrders(first: 1, ids: $ids) {
    edges {
      node {
        id
        name
        verified
        grandTotal
        shippingTotal
        paymentMethod
        status
        discounts {
          id
          name
        }
        lines(first: 99) {
          edges {
            node {
              id
              name
              quantity
              unitPrice
              rowTotal
              product {
                id
                sku
                name
                brand {
                  id
                  name
                }
              }
              children(first: 99) {
                edges {
                  node {
                    id
                    name
                    quantity
                    unitPrice
                    product {
                      id
                      sku
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitPrice",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sku",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    },
    {
      "kind": "Variable",
      "name": "ids",
      "variableName": "ids"
    }
  ],
  "concreteType": "SalesOrderConnection",
  "kind": "LinkedField",
  "name": "salesOrders",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesOrderEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesOrder",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "verified",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "grandTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shippingTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentMethod",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Discount",
              "kind": "LinkedField",
              "name": "discounts",
              "plural": true,
              "selections": (v3/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v4/*: any*/),
              "concreteType": "SalesOrderLineConnection",
              "kind": "LinkedField",
              "name": "lines",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SalesOrderLineEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SalesOrderLine",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v5/*: any*/),
                        (v6/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "rowTotal",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Product",
                          "kind": "LinkedField",
                          "name": "product",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            (v7/*: any*/),
                            (v2/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Brand",
                              "kind": "LinkedField",
                              "name": "brand",
                              "plural": false,
                              "selections": (v3/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": (v4/*: any*/),
                          "concreteType": "SalesOrderLineConnection",
                          "kind": "LinkedField",
                          "name": "children",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SalesOrderLineEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "SalesOrderLine",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v2/*: any*/),
                                    (v5/*: any*/),
                                    (v6/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Product",
                                      "kind": "LinkedField",
                                      "name": "product",
                                      "plural": false,
                                      "selections": [
                                        (v1/*: any*/),
                                        (v7/*: any*/)
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": "children(first:99)"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "lines(first:99)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_BeforeSuccess_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BeforeSuccess_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_BeforeSuccess_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a1f6ac6f654a6b5f358371a80c1bc31",
    "id": null,
    "metadata": {},
    "name": "routes_BeforeSuccess_Query",
    "operationKind": "query",
    "text": "query routes_BeforeSuccess_Query(\n  $ids: [ID!]\n) {\n  viewer {\n    ...BeforeSuccess_viewer\n    salesOrders(first: 1, ids: $ids) {\n      edges {\n        node {\n          id\n          name\n          verified\n          grandTotal\n          shippingTotal\n          paymentMethod\n          status\n          discounts {\n            id\n            name\n          }\n          lines(first: 99) {\n            edges {\n              node {\n                id\n                name\n                quantity\n                unitPrice\n                rowTotal\n                product {\n                  id\n                  sku\n                  name\n                  brand {\n                    id\n                    name\n                  }\n                }\n                children(first: 99) {\n                  edges {\n                    node {\n                      id\n                      name\n                      quantity\n                      unitPrice\n                      product {\n                        id\n                        sku\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment BeforeSuccess_viewer on Customer {\n  salesOrders(first: 1, ids: $ids) {\n    edges {\n      node {\n        id\n        name\n        verified\n        grandTotal\n        shippingTotal\n        paymentMethod\n        status\n        discounts {\n          id\n          name\n        }\n        lines(first: 99) {\n          edges {\n            node {\n              id\n              name\n              quantity\n              unitPrice\n              rowTotal\n              product {\n                id\n                sku\n                name\n                brand {\n                  id\n                  name\n                }\n              }\n              children(first: 99) {\n                edges {\n                  node {\n                    id\n                    name\n                    quantity\n                    unitPrice\n                    product {\n                      id\n                      sku\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '95c4fb950def9ed8a0e8db8633450d42';

module.exports = node;
